import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./CameraViewChangeButton.scss";
import { FormattedMessage } from "react-intl";
import { ReactComponent as ThirdPerson } from "../icons/ThirdPerson.svg";
import { ReactComponent as FirstPerson } from "../icons/FirstPerson.svg";
import { CAMERA_MODE_FIRST_PERSON, CAMERA_MODE_THIRD_PERSON_NEAR } from "../../systems/camera-system";
export function CameraViewChangeButton({ scene }) {
  const [cameraMode, setCameraMode] = useState(CAMERA_MODE_FIRST_PERSON);
  const toggleCameraMode = useCallback(
    e => {
      const cameraSystem = scene.systems["hubs-systems"].cameraSystem;
      if (cameraSystem.mode == CAMERA_MODE_FIRST_PERSON || cameraSystem.mode == CAMERA_MODE_THIRD_PERSON_NEAR) {
        cameraSystem.toggleCameraMode();
        setCameraMode(cameraSystem.mode);
      }
    },
    [scene]
  );
  const renderButton = () => {
    let icon = cameraMode == CAMERA_MODE_FIRST_PERSON ? <FirstPerson /> : <ThirdPerson />;
    return (
      <>
        <label className={styles.toggleCameraButtonLabel}>
          <FormattedMessage id="camera-mode-button.label" defaultMessage="Camera mode" />
        </label>
        <div className={styles.toggleCameraButtonIcon}>{icon}</div>
      </>
    );
  };
  return (
    <div
      className={`${styles.toggleCameraButtonContainer} ${styles["mode" + cameraMode]} ${
        styles["signIn" + window.APP.hubChannel._signedIn]
      }`}
      onClick={toggleCameraMode}
    >
      {renderButton()}
    </div>
  );
}
